import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const SmejdTeaser = () => {
  return (
    <section id="nebud-smejd" data-testid="smejd-teaser-section" className="py-24 md:py-32 border-t border-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 grid lg:grid-cols-2 gap-12 lg:gap-20">
        <Reveal className="order-2 lg:order-1 flex">
          <img
            src="/images/par-pohovka.webp"
            alt="Klienti doma nad pojistnými dokumenty — ilustrační fotografie"
            width={1200}
            height={685}
            loading="lazy"
            data-testid="smejd-teaser-image"
            className="w-full h-auto lg:h-full lg:object-cover block rounded-tr-[80px] rounded-2xl"
          />
        </Reveal>
        <Reveal delay={0.1} className="order-1 lg:order-2">
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Nebuď šmejd
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-[#252525] mt-6">
            Příběhy, ze kterých bolí hlava
          </h2>
          <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed mt-6">
            Špatně nastavenou smlouvu poznáte většinou až ve chvíli, kdy je pozdě.
            Sdílím skutečné příběhy klientů, kteří přišli o peníze kvůli nešťastně
            sjednanému pojištění — abyste se z nich mohli poučit včas.
          </p>
          <Link
            to="/pribehy"
            data-testid="smejd-teaser-link"
            className="group mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-widest font-medium text-[#252525] border-b border-[#B69A58] pb-1 hover:text-[#B69A58] transition-colors duration-300"
          >
            Přečíst příběhy klientů
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
